<template>
    <header>
        <nav class="navbar container no-indent is-max-desktop" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item home" href="/" aria-label="Forside">
                    <span class="icon">
                        <Icon name="home" size="xl" />
                    </span>
                </a>
                <a class="navbar-item calendar is-hidden-desktop" href="/kalender" aria-label="Kalender">
                    <span class="icon">
                        <Icon name="calendar" />
                    </span>
                </a>
                <a
                    role="button"
                    class="navbar-burger"
                    :class="{ 'is-active': menuOpen }"
                    aria-label="menu"
                    :aria-expanded="menuOpen ? 'true' : 'false'"
                    aria-controls="navbar"
                    @click="toggleMenu"
                >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div
                class="nav-backdrop is-hidden-desktop"
                :class="{ 'is-active': menuOpen }"
                @click="closeMenu"
            ></div>

            <div id="navbar" class="navbar-menu" :class="{ 'is-active': menuOpen }">
                <div class="nav-drawer-inner">
                    <p class="nav-section-label is-hidden-desktop">Sider</p>
                    <div class="navbar-start">
                        <a
                            v-for="page in global.navigation.pages"
                            :key="page.id"
                            :href="page.url"
                            class="navbar-item"
                            @click="closeMenu"
                        >{{ page.name }}</a>
                    </div>

                    <p class="nav-section-label is-hidden-desktop">Booking</p>
                    <div class="navbar-end">
                        <div
                            v-if="global.user.hasOwnProperty('accessLvl') && global.user.accessLvl == 1"
                            class="navbar-item is-hidden-desktop"
                        >
                            <a
                                href="/admin"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('admin') }"
                                @click="closeMenu"
                            >Admin</a>
                        </div>
                        <div class="navbar-item">
                            <a
                                href="/kalender"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('kalender') }"
                                @click="closeMenu"
                            >Kalender</a>
                        </div>
                        <div class="navbar-item is-hidden-desktop">
                            <a
                                href="/mine-bookinger"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('mine-bookinger') }"
                                @click="closeMenu"
                            >Mine bookinger</a>
                        </div>
                        <div v-if="global.user.hasOwnProperty('id')" class="navbar-item is-hidden-desktop">
                            <a
                                :href="forbrugHref"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('forbrug') }"
                                @click="closeMenu"
                            >Forbrug</a>
                        </div>
                        <div v-if="global.user.hasOwnProperty('id')" class="navbar-item">
                            <a
                                href="/medlemmer"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('medlemmer') }"
                                @click="closeMenu"
                            >Medlemmer</a>
                        </div>
                    </div>

                    <div
                        v-if="isLoggedIn"
                        ref="sessionRoot"
                        class="nav-session"
                        :class="{ 'is-open': accountMenuOpen }"
                    >
                        <button
                            type="button"
                            class="button is-medium nav-session__trigger is-hidden-touch"
                            :aria-expanded="accountMenuOpen ? 'true' : 'false'"
                            aria-haspopup="true"
                            :title="'Id: ' + global.user.id"
                            @click="toggleAccountMenu"
                        >
                            <span class="nav-session__trigger-label">{{ accountTriggerLabel }}</span>
                            <Icon name="chevron-down" size="sm" />
                        </button>
                        <div
                            v-show="accountMenuOpen"
                            class="nav-session__dropdown is-hidden-touch"
                            role="menu"
                        >
                            <p class="nav-session__name" :title="'Id: ' + global.user.id">
                                {{ global.user.displayName }}
                            </p>
                            <p class="nav-session__account">{{ global.user.accountName }}</p>
                            <NavSessionPhone ref="phoneDesktop" />
                            <nav class="nav-session__links" aria-label="Konto">
                                <a
                                    href="/mine-bookinger"
                                    class="nav-session__link"
                                    :class="{ 'is-active': isNavActive('mine-bookinger') }"
                                    role="menuitem"
                                    @click="accountMenuOpen = false"
                                >Mine bookinger</a>
                                <a
                                    :href="forbrugHref"
                                    class="nav-session__link"
                                    :class="{ 'is-active': isNavActive('forbrug') }"
                                    role="menuitem"
                                    @click="accountMenuOpen = false"
                                >Forbrug</a>
                                <a
                                    v-if="global.user.accessLvl == 1"
                                    href="/admin"
                                    class="nav-session__link"
                                    :class="{ 'is-active': isNavActive('admin') }"
                                    role="menuitem"
                                    @click="accountMenuOpen = false"
                                >Admin</a>
                            </nav>
                            <button
                                type="button"
                                class="button nav-session__logout"
                                aria-label="Log ud"
                                @click="logout"
                            >
                                <Icon name="sign-out" size="sm" />
                                <span class="nav-session__logout-text">Log ud</span>
                            </button>
                        </div>

                        <div class="nav-session__panel is-hidden-desktop">
                            <div class="nav-session__row">
                                <div class="nav-session__meta">
                                    <p class="nav-session__name" :title="'Id: ' + global.user.id">
                                        {{ global.user.displayName }}
                                    </p>
                                    <p class="nav-session__account">{{ global.user.accountName }}</p>
                                </div>
                                <button
                                    type="button"
                                    class="button nav-session__logout"
                                    aria-label="Log ud"
                                    @click="logout"
                                >
                                    <Icon name="sign-out" size="sm" />
                                    <span class="nav-session__logout-text">Log ud</span>
                                </button>
                            </div>
                            <NavSessionPhone />
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
    <BookingCreateFab />
</template>

<script>
import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'
import { logout, clearLocalUser, redirectHome } from '@/auth/sessionApi'
import Icon from '@/components/Icon.vue'
import BookingCreateFab from '@/components/BookingCreateFab.vue'
import NavSessionPhone from '@/components/NavSessionPhone.vue'

export default defineComponent({
    components: {
        Icon,
        BookingCreateFab,
        NavSessionPhone
    },
    setup() {
        const { global } = useComposition();
        return { global }
    },
    data() {
        return {
            menuOpen: false,
            accountMenuOpen: false
        }
    },
    computed: {
        isLoggedIn() {
            return this.global.user && Object.prototype.hasOwnProperty.call(this.global.user, 'id')
        },
        currentPath() {
            return this.$route.path || ''
        },
        forbrugHref() {
            const guid = this.global.user && this.global.user.accountGuid
            if (guid && Number(this.global.user.accessLvl) !== 1) {
                return '/forbrug?account=' + encodeURIComponent(guid)
            }
            return '/forbrug'
        },
        accountTriggerLabel() {
            const name = String((this.global.user && this.global.user.displayName) || '').trim()
            if (!name) return 'Konto'
            const first = name.split(/\s+/)[0]
            return first || name
        }
    },
    watch: {
        menuOpen(open) {
            document.documentElement.classList.toggle('nav-drawer-open', open)
            if (open) {
                this.accountMenuOpen = false
            }
        },
        accountMenuOpen(open) {
            if (!open) {
                const phone = this.$refs.phoneDesktop
                if (phone && typeof phone.cancel === 'function') {
                    phone.cancel()
                }
            }
        },
        '$route'() {
            this.closeMenu()
            this.accountMenuOpen = false
        }
    },
    mounted() {
        document.addEventListener('click', this.onDocumentClick)
    },
    beforeUnmount() {
        document.documentElement.classList.remove('nav-drawer-open')
        document.removeEventListener('click', this.onDocumentClick)
    },
    methods: {
        isNavActive(section) {
            const path = this.currentPath
            if (section === 'kalender') {
                return path === '/kalender' || path.startsWith('/booking')
            }
            if (section === 'mine-bookinger') {
                return path === '/mine-bookinger' || path.startsWith('/mine-bookinger/')
            }
            if (section === 'admin') {
                return path === '/admin' || path.startsWith('/admin/')
            }
            if (section === 'forbrug') {
                return path === '/forbrug' || path.startsWith('/forbrug/')
            }
            if (section === 'medlemmer') {
                return path === '/medlemmer' || path.startsWith('/medlemmer/')
            }
            return false
        },
        toggleMenu() {
            this.menuOpen = !this.menuOpen
        },
        closeMenu() {
            this.menuOpen = false
        },
        toggleAccountMenu(event) {
            if (event) {
                event.stopPropagation()
            }
            this.accountMenuOpen = !this.accountMenuOpen
        },
        onDocumentClick(event) {
            if (!this.accountMenuOpen) return
            const root = this.$refs.sessionRoot
            if (root && !root.contains(event.target)) {
                this.accountMenuOpen = false
            }
        },
        async logout() {
            this.closeMenu()
            this.accountMenuOpen = false
            try {
                await logout()
                clearLocalUser(this.global)
                redirectHome()
            } catch (error) {
                redirectHome()
            }
        }
    }
})
</script>
